import React, { createContext, useContext } from "react";

const PostsContext = createContext();

function PostsProvider({ children, value, categories, quiz }) {
  return (
    <PostsContext.Provider
      value={{ posts: value, categories: categories, quiz: quiz }}
    >
      {children}
    </PostsContext.Provider>
  );
}

const usePosts = () => useContext(PostsContext);
export { PostsContext, usePosts };
export default PostsProvider;
